<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">Contact us</span><br>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4">

  <div class="row mt-4 mb-3">
    <div class="col-12 col-lg-6 offset-lg-3">
      <p>
        Have a question or a little unsure what to do, then please <a href="https://identicare.zendesk.com/hc/en-us" target="_blank">click here</a> to visit our Help Centre. We’ve compiled the answers and guidance to some of the most common questions and problems.
      </p>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12 col-lg-6 offset-lg-3">
      <h4 class="py-2">Contact details</h4>
      <p>
        <strong>Tel:</strong> {{ COMPANY_PHONE_NUMBER }}
      </p>
      <p *ngIf="userService.isUserStoredInServicePremium() || userService.isUserStoredInServiceBasicPlus()">
        <strong>Missing pet line:</strong> 03309 128001
      </p>
      <p>
        <strong>Email:</strong> hello&#64;identibase.co.uk
      </p>
      <p>
        <strong>Address:</strong> identibase, Moorside, Monks Cross Drive, Huntington, York, YO32 9LB
      </p>
    </div>
  </div>

</div>
